import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/sidebar';
import Topbar from '../topbar/topbar';
import { ActionForbidden } from '../../ui/modal/actionForbidden/actionForbidden';
import CashFlowModal from '../../dashboards/components/widget/cashflow/cashFlowModal/cashFlowModal';
import DocuSignLoadingModal from '../../ui/modal/docuSignLoadingModal/docuSignLoadingModal';
import MultipleDownloadModal from '../../ui/modal/multipleDownload/multipleDownload';
import SelectedDocsLimitModal from '../../ui/modal/selectedDocsLimitModal/selectedDocsLimitModal';

import './basicScreen.scss';

const BasicScreen: React.FC = () => {
  return (
    <div className={'basic-screen-wrapper'}>
      <Sidebar />
      <div className="content-wrapper">
        <Topbar />
        <Outlet />
      </div>
      <CashFlowModal />
      <ActionForbidden />
      <DocuSignLoadingModal />
      <MultipleDownloadModal />
      <SelectedDocsLimitModal />
    </div>
  );
};

export default BasicScreen;
